var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1740384735620,
    className: "icon",
    viewBox: "0 0 1296 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 12761,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 253.125,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 839.195266a677.112426 677.112426 0 0 0 26.508876 184.804734 668.781065 668.781065 0 0 1 621.065088-484.733728v160.568048a37.869822 37.869822 0 0 0 56.804734 32.568047l573.349113-330.982249a37.869822 37.869822 0 0 0 0-65.136094L704.378698 5.301775a37.869822 37.869822 0 0 0-56.804734 32.568047v131.786983A669.538462 669.538462 0 0 0 0 839.195266z",
    "p-id": 12762,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJump);
export default __webpack_public_path__ + "static/media/jump.d7640a48c545cec6acc8be5a409ec286.svg";
export { ForwardRef as ReactComponent };